import {watch} from 'vue';
import {useClientSettingsContextStore} from '@common/stores';
import {defineNuxtPlugin} from 'nuxt/app';
import {storeToRefs} from 'pinia';
import {useAuth} from '#imports';

export default defineNuxtPlugin(async () => {
    const auth = useAuth();
    const {loggedIn} = storeToRefs(auth);

    watch(
        loggedIn,
        async () => {
            if (loggedIn.value) {
                try {
                    const clientSettingsContextStore = useClientSettingsContextStore();
                    await clientSettingsContextStore.fetchClientSettingsContext();
                } catch (error) {
                    window.captureException?.(error);
                }
            }
        },
        {immediate: true},
    );
});
